<template>
  <!-- 尾 -->
  <footer>
    <div class="top_box">
      <div class="top">
        <div class="circle">
          <img src="img/arrow.svg" alt="">
        </div>
      </div>
    </div>
    <a href="#AB" class="accesskey" title="下方功能區塊" accesskey="B" name="B">:::</a>
    <div class="container">
      <div class="text_box" v-if="FooterData" v-coep-html="FooterData.Footer_Text">
      </div>
    </div>
  </footer>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

export default {
  name: "Footer",
  data() {
    return {
      FooterData: null,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Footer",
        {
          params: { lang: $cookies.get("is_site_lang") },
        }
      )
      .then((response) => {
        this.FooterData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    $("html body").scroll(function () {
      var TOP = $("#app").scrollTop();
      if (TOP > 600) {
        $('.top_box').show();
      }
      else {
        $('.top_box').hide();
      };
    });
    $(".top_box").click(function () {
      $('html,body').animate({ scrollTop: 0 }, 1000);
    });
  },
};
</script>
